import { getIBHedgeIntents } from '@/api/ibModule';

export const STATUS_FILTERS = {
  all: null,
  ready: 'ready_to_trade',
  onboarding: 'onboarding_in_progress',
  needs_account: 'no_account_yet',
};

export const SORT_OPTIONS = [
  { value: 'largest_acres', label: 'Largest acres first' },
  { value: 'smallest_acres', label: 'Smallest acres first' },
  { value: 'most_active', label: 'Most active' },
];

export const ACRES_CEILING = 10000;
export const ACRES_STEP = 250;

const SEEN_LEADS_KEY = 'ib_hedge_intents_seen_leads';

function loadSeenLeads() {
  try {
    return JSON.parse(localStorage.getItem(SEEN_LEADS_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function persistSeenLeads(seen) {
  try {
    localStorage.setItem(SEEN_LEADS_KEY, JSON.stringify(seen));
  } catch (e) {
    // Ignore
  }
}

function sortLeads(leads, sortBy) {
  const sorted = [...leads];
  if (sortBy === 'smallest_acres') {
    sorted.sort((a, b) => (a.acres || 0) - (b.acres || 0));
  } else if (sortBy === 'most_active') {
    sorted.sort((a, b) => (b.activity || 0) - (a.activity || 0));
  } else {
    sorted.sort((a, b) => (b.acres || 0) - (a.acres || 0));
  }
  return sorted;
}

export default {
  namespaced: true,

  state: () => ({
    leads: [],
    counts: { all: 0, ready: 0, onboarding: 0, needs_account: 0 },
    loading: false,
    statusFilter: 'all',
    minAcres: 0,
    sortBy: 'largest_acres',
    seenLeads: loadSeenLeads(),
  }),

  getters: {
    filteredLeads(state) {
      const statusValue = STATUS_FILTERS[state.statusFilter];
      const filtered = state.leads.filter((lead) => {
        if (statusValue && lead.accountStatus !== statusValue) return false;
        if ((lead.acres || 0) < state.minAcres) return false;
        return true;
      });
      return sortLeads(filtered, state.sortBy);
    },
    totalCount(state) {
      return state.leads.length;
    },
    visibleCount(state, getters) {
      return getters.filteredLeads.length;
    },
    isFilteredEmpty(state, getters) {
      return state.leads.length > 0 && getters.filteredLeads.length === 0;
    },
    newLeadCount(state) {
      return state.leads.filter((lead) => !state.seenLeads[lead.id]).length;
    },
  },

  mutations: {
    setLeads(state, leads) {
      state.leads = Array.isArray(leads) ? leads : [];
    },
    setCounts(state, counts) {
      state.counts = counts || { all: 0, ready: 0, onboarding: 0, needs_account: 0 };
    },
    setLoading(state, value) {
      state.loading = Boolean(value);
    },
    setStatusFilter(state, value) {
      state.statusFilter = value in STATUS_FILTERS ? value : 'all';
    },
    setMinAcres(state, value) {
      state.minAcres = Number(value) || 0;
    },
    setSortBy(state, value) {
      state.sortBy = value || 'largest_acres';
    },
    markHedgeIntentsSeen(state) {
      const seen = {};
      state.leads.forEach((lead) => {
        seen[lead.id] = true;
      });
      state.seenLeads = seen;
      persistSeenLeads(seen);
    },
  },

  actions: {
    async loadHedgeIntents({ commit }) {
      commit('setLoading', true);
      try {
        const payload = await getIBHedgeIntents();
        commit('setLeads', payload.leads);
        commit('setCounts', payload.counts);
      } finally {
        commit('setLoading', false);
      }
    },
    setStatusFilter({ commit }, value) {
      commit('setStatusFilter', value);
    },
    setMinAcres({ commit }, value) {
      commit('setMinAcres', value);
    },
    setSortBy({ commit }, value) {
      commit('setSortBy', value);
    },
    markHedgeIntentsSeen({ commit }) {
      commit('markHedgeIntentsSeen');
    },
  },
};
